export interface IEquipment {
  id?: number;
  name?: string;
  description?: string;
}
